import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field} from "formik";
import * as Yup from "yup";
import api from "../../../service/api";
import routes from "../../../routes/configurationAdmin.routes";
// Components
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import NavTabs from "../../../components/NavTabs";
import { 
    ButtonContainer, TitleField, RowForInput, 
    InputContainer, ColumnForTwoInputs, RowForTwoInput, 
    InputWithHintContainer, EstablishmentSelected, MessageError, 
    MessageErrorApi
} from "./styles";
//Assets
import hint from "../../../assets/icons/hint.svg";

const Bank = () => {
    const [perfilImage, setPerfilImage] = useState<File>();
    const [logoImg, setLogoImg] = useState<File>();
    const { establishment } = useSelector((state: {establishment: any}) => state.establishment)
    const [errorOnApi, setErrorOnApi] = useState(false);
    const login = useSelector((state: {login: any}) => state.login);
    const dispatch = useDispatch();
    const history = useHistory();
    const [selectedBank, setSelectedBank] = useState("");
    const [dataBanks, setDataBanks] = useState<Array<any>>([
        {
            value: "",
            label: ""
        }
    ]);
    
    useEffect(() => {
        if(login.user.groups.mc6 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const formValidationWithYup = Yup.object().shape({
        routing_number: Yup.string().required("*Obrigatório"),
        routing_digit: Yup.string().required("*Obrigatório"),
        account_number: Yup.string().required("*Obrigatório").min(5,"Quantidade de números inválida"),
        holder_name: Yup.string().required("*Obrigatório").min(2,"Nome pequeno demais"),
    });

    useEffect(()=>{
        const getBanks = async () => {
            const {data} = await api.get("banks/list")
            
            setDataBanks(data)
        }
        
        if(establishment !== {}) {
            getBanks();
        }
    }, [establishment])

    const generateOptionsBanks = () => {
        return dataBanks.map((item, index) => {
            return (
                <option key={index} value={item.label} >
                </option>
            )
        })
    }
    
    return(
        <div>
            <Header title="Banco" subTitle="Vincule uma conta bancária ao estabelecimento" subTitleWidth={239}/>
            <NavTabs tabs={routes}/>
                <TitleField>
                    Estabelecimento selecionado: 
                    <EstablishmentSelected>
                        {` ${establishment.businessName ?? "nenhum, selecione um no dashboard."}`} 
                    </EstablishmentSelected>
                </TitleField>
                {
                    Object.keys(establishment).length > 0
                    ? <Formik
                        initialValues={{
                            bank: "",
                            account_number: "",
                            routing_number: "",
                            routing_digit: selectedBank,
                            holder_name: "",
                        }}
                        validationSchema={formValidationWithYup}
                        onSubmit={async (values, {resetForm}) => {
                            try {
                                if(establishment.ein !== null) { // Pessoa jurídica
                                    await api.post("/adm/ownerbranch/bank/create", {
                                        holder_name: values.holder_name,
                                        bank_code: selectedBank,
                                        routing_number: values.routing_number.toString(),
                                        account_number: values.account_number.toString(),
                                        taxpayer_id: null,
                                        ein: establishment.ein,
                                        sellerOwnerPayId: establishment?.sellerOwnerPayId
                                    });
                                    resetForm();
                                    setErrorOnApi(false);
                                } 
                                
                                if (establishment.ein === null) { // Pessoa física
                                        await api.post("/adm/ownerbranch/bank/create", {
                                        holder_name: values.holder_name,
                                        bank_code: selectedBank,
                                        routing_number: values.routing_number.toString(),
                                        account_number: values.account_number.toString(),
                                        taxpayer_id: establishment.taxpayerIdBranch!,
                                        ein: null,
                                        sellerOwnerPayId: establishment?.sellerOwnerPayId
                                    });
                                    resetForm();
                                    setErrorOnApi(false);
                                }
                            } catch (error) {
                                setErrorOnApi(true);
                            }
                        }}
                    >
                        {({initialValues, values, errors, dirty, isValid, touched}) => {
                            initialValues.routing_digit = selectedBank
                            
                            return(
                                <Form>
                                    <TitleField>Dados da conta bancária</TitleField>
                                    <RowForInput>
                                    <InputContainer>
                                        <Field
                                            onKeyUp={() => {
                                                dataBanks.map((item) => {
                                                    if(item.label === values.bank){
                                                        setSelectedBank(item.value as string)
                                                    }
                                                })
                                            }}
                                            list="bank" 
                                            name="bank"
                                            placeholder="Insira um banco"
                                            as={Input}
                                        />
                                        <datalist id="bank" > 
                                        { generateOptionsBanks() }
                                        </datalist>
                                    </InputContainer>
                                    
                                    <ColumnForTwoInputs>
                                        <RowForTwoInput>
                                        <InputContainer style={{width: "65%"}}>
                                            <Field minLength={5} id="routing_number" type="number" name="routing_number" placeholder="Agência" 
                                                as={Input}
                                                style={{borderColor: `${touched.routing_number && errors.routing_number ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            />
                                            {touched.routing_number && errors.routing_number ? <MessageError>{ errors.routing_number }</MessageError> : null}
                                        </InputContainer>
                                        <InputContainer style={{width: "30%"}}>
                                            <Field id="routing_digit" name="routing_digit" type="number" value={selectedBank}  onChange={(e: any) => {
                                                    setSelectedBank(e.target.value)
                                                    values.routing_digit = e.target.value
                                                }} 
                                                placeholder="Dígito" 
                                                style={{borderColor: `${touched.routing_digit && errors.routing_digit ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                as={Input}
                                            />
                                            {touched.routing_digit && errors.routing_digit ? <MessageError>{ errors.routing_digit }</MessageError> : null}
                                        </InputContainer>
                                        </RowForTwoInput>
                                    </ColumnForTwoInputs>
                                    </RowForInput>

                                    <RowForInput>
                                    <InputContainer>
                                        <Field id="account_number" name="account_number" type="number" placeholder="Conta" 
                                            style={{borderColor: `${touched.account_number && errors.account_number ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            as={Input}
                                        />
                                        {touched.account_number && errors.account_number ? <MessageError>{errors.account_number}</MessageError> : null}
                                    </InputContainer>
                                    <InputContainer>
                                        <Field id="holder_name" name="holder_name" placeholder="Nome do Titular"
                                            style={{borderColor: `${touched.holder_name && errors.holder_name ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            as={Input}
                                        />
                                        {touched.holder_name && errors.holder_name ? <MessageError>{errors.holder_name}</MessageError> : null}
                                    </InputContainer>
                                    </RowForInput>

                                    <RowForInput>
                                    <InputContainer>
                                        <InputWithHintContainer>
                                        <Field value={establishment.taxpayerIdBranch!} disabled as={Input}/>
                                        <img src={hint} alt="Dica" style={{marginLeft: 3}}/>
                                        </InputWithHintContainer>
                                    </InputContainer>
                                    </RowForInput>
                                    <ButtonContainer>
                                        {
                                            errorOnApi
                                            ? <MessageErrorApi>Tivemos um problema, tente novamente ou entre em contato com o suporte.</MessageErrorApi>
                                            : null
                                        }
                                        <Button 
                                            type="submit"
                                            onClick={() => {}}
                                            disabled={ !(dirty && isValid) }
                                        >
                                            Adicionar
                                        </Button>
                                    </ButtonContainer>
                                </Form>
                            )
                        }}
                    </Formik>
                    : null
                }
        </div>
    )
}

export default Bank;